class MobileAmbassadorFlickity {
  constructor() {
    if (!document.querySelector(".mobile-ammb-tumbs-carousel")) return;

    // mobile side
    const tabFlickity = new Flickity(".mobile-ammb-tumbs-carousel", {
      pageDots: false,
      prevNextButtons: false,
      draggable: true,
      wrapAround: true,
    });

    const mobileSlidesFlickity = new Flickity(".mobile-ammb-slides-carousel", {
      pageDots: false,
      prevNextButtons: false,
      wrapAround: true,
      draggable: false,
    });
    const flickitys = [tabFlickity, mobileSlidesFlickity];
    tabFlickity.on("staticClick", (event, pointer, cellElement, cellIndex) => {
      flickitys.forEach((_flickity) => {
        _flickity.select(cellIndex);
      });
    });
    tabFlickity.on("dragEnd", (index) => {
      flickitys.forEach((_flickity) => {
        _flickity.select(tabFlickity.selectedIndex);
      });
    });
  }
}

if (typeof MobileAmbassadorFlickity !== "undefined") {
  new MobileAmbassadorFlickity();
}

class DesktopAmbassadorFlickity {
  constructor() {
    if (!document.querySelector("#ambassadors-slides-carousel")) return;

    // desktop side
    let _slidesCarousel = document.querySelector(
      "#ambassadors-slides-carousel",
    );

    const slidesFlickity = new Flickity(_slidesCarousel, {
      pageDots: false,
      contain: true,
      prevNextButtons: false,
      draggable: false,
      cellAlign: "left",
      wrapAround: true,
    });

    let _tabCarousel = document.querySelector("#ambassadors-tumbs-carousel");

    const tabFlickity = new Flickity(_tabCarousel, {
      pageDots: false,
      contain: true,
      prevNextButtons: false,
      draggable: false,
      cellAlign: "left",
      wrapAround: true,
      percentPosition: false,
    });

    const flickitys = [tabFlickity, slidesFlickity];
    flickitys.forEach((flickity) => {
      flickity.on("staticClick", (event, pointer, cellElement, cellIndex) => {
        flickitys.forEach((_flickity) => {
          _flickity.select(cellIndex);
        });
      });
      flickity.on("dragEnd", (index) => {
        const selectedIndex = flickity.selectedIndex;
        flickitys.forEach((_flickity) => {
          _flickity.select(selectedIndex);
        });
      });
    });
  }
}

if (typeof DesktopAmbassadorFlickity !== "undefined") {
  new DesktopAmbassadorFlickity();
}
